Spline     = require("lib/draw/catmull-rom-spline")
Simplify   = require("lib/draw/simplify")
animate    = require("lib/animate")

class SmoothLine
  constructor: (@points = [], @__color, @__width) ->
    @timestamp = Date.now()

  add: (p) ->
    @points.push p

    recent  = @points.slice(-50, -1)
    rest    = @points.slice(1, -recent.length - 1)
    first   = @points.slice(0, 1)
    last    = @points.slice(-1)
    simple  = Simplify(recent, Math.pow(recent.length, 0.3), true)
    @points = first.concat(rest, simple, last)

    return this

  remove: (fromStart) ->
    if fromStart then @points.shift() else @points.pop()

  length: ->
    @points.length

  getSpline: ->
    Spline @points

  getPoints: ->
    [].concat(@points)

  erase: (context, frame) ->
    spline = _.clone(@getSpline()).reverse()
    length = spline.length - 1
    width  = @__width

    draw = (dist) =>
      frame?(dist)

      context.globalAlpha = 1 - dist

      return unless spline.length > 1

      index    = Math.ceil dist * length
      points   = spline.slice(0, Math.max(length - index + 1, 2))
      [p1, p2] = points.slice(-2)
      diff     = (index / length - dist) * length
      diffX    = diff * (p1.x - p2.x)
      diffY    = diff * (p1.y - p2.y)

      points[points.length - 1] = x: p1.x - diffX, y: p1.y - diffY

      @__width = width + Math.sin(dist * Math.PI) * width * 1.2

      @points = points
      @draw(context, false)

      # Reset
      @__width = width if dist is 1

    duration = Math.max Math.min(Date.now() - @timestamp, 3000), 600
    @animation = animate(draw, duration)

  draw: (ctx, smooth = true) ->
    line = if smooth then @getSpline() else @points

    ctx.strokeStyle = @__color if @__color
    ctx.lineWidth   = @__width if @__width

    if line.length > 1
      ctx.beginPath()
      ctx[if i is 0 then "moveTo" else "lineTo"](x, y) for {x, y}, i in line
      ctx.stroke()

module.exports = SmoothLine
